import React, { useEffect, useRef, useState } from "react";
import "./MobileSilder.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import axios from "axios";
import SingleItem from "./SingleItem";
import Skeleton from "react-loading-skeleton";
const MobileSilder = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(
        `https://api.wlffinance.org/api/frontend/home/news/view`
      )
      .then((res) => {
        setData(res?.data?.data);
        setLoading(false);
      })
      .catch((err) => {});
  }, []);

  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle.current.style.setProperty("--progress", 1 - progress);
    progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  };

  if (loading) {
    return (
      <>
        <section className="mobile-version">
          <div className="Mobile-version-slider">
            <div className="container">
              <Skeleton count={1} height={150} />
            </div>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      <main className="mobile-home-slider-news-section mobile-news-section">
        <div className="container">
          <div className="main-newes-area">
            <Swiper
              spaceBetween={30}
              centeredSlides={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              loop={true}
              navigation={true}
              modules={[Autoplay]}
              onAutoplayTimeLeft={onAutoplayTimeLeft}
              className="user-home-slider"
            >
              {data.map((data, index) => {
                if (data) {
                  return (
                    <SwiperSlide key={data?._id}>
                      <SingleItem
                        data={data}
                        index={index}
                        key={data._id}
                      ></SingleItem>
                    </SwiperSlide>
                  );
                }
              })}
              <div className="autoplay-progress d-none" slot="container-end">
                <svg viewBox="0 0 48 48" ref={progressCircle}>
                  <circle cx="24" cy="24" r="20"></circle>
                </svg>
                <span ref={progressContent}></span>
              </div>
            </Swiper>
          </div>
        </div>
      </main>
    </>
  );
};

export default MobileSilder;
